import { BaseObject, IBaseObject } from './BaseObject';

export interface IAlarme extends IBaseObject {
  dateDeclenchement: Date;
  idEtat: number;
  idExterne?: number;
  localisation?: string;
  description?: string;
  idCriticite?: number;
  descriptionCriticite?: string;
  descriptionEtat?: string;
  urlDetail?: string;
  nomSousSysteme?: string;
}

export class Alarme extends BaseObject implements IAlarme {
  idEtat = -1;
  dateDeclenchement = new Date();
  urlDetail!: string;
  idExterne!: number;
  localisation!: string;
  description!: string;
  idCriticite!: number;
  descriptionCriticite!: string;
  descriptionEtat!: string;
  nomSousSysteme!: string;

  constructor(props?: IAlarme) {
    super(props);

    if (props) {
      Object.assign(this, props);
    }
  }

  public format(): IAlarme {
    return {
      id: this.id,
      idEtat: this.idEtat,
      dateDeclenchement: this.dateDeclenchement,
    };
  }
}
